import Block from '_core_ext/core/common/Block';
import layout from '_core_ext/layout';
import cookie from '_core_ext/cookie';
import searchsuggest from '../../searchsuggest';

const CHILDREN_COMPONENTS_IDS = [
    'headerNavigationContainer',
    'headerSearchContainer'
];

export default class Header extends Block {
    init() {
        super.init();
        this.settings = {};
        this.activeViewMode = 'desktop';
        this.isTablet = layout.isTablet();
        this.isTransparentEnabled = $('.homePageTransparentHeader').val() === 'true';
        this.initConfig(this.settings);
        this.updateChildrenReferences();
        this.subscribeToChildrenEvents();
        this.onWindowModeChanged({mode: layout.getMode()});
        this.subscribeToGlobalEvents();

        this.initTransparency();
        this.initCatFlyoutInactive();
        this.initSlotConfigDisabled();
        this.initSlotConfigEnabled();
        this.headerNavigationContainer.initNavigationStyles();
        if (this.isTablet) {
            this.headerNavigationContainer.setDevice('tablet');
        }
        this.setMobileHeaderPositionTop();

        this.event('click', '.js-header-nav-toggle', this.toggleNavigation.bind(this));
        this.event('click', '.js-overlay-nav', this.onOverlayClick.bind(this));
        this.event('click', '.js-toggle-search', this.toggleSearchForm.bind(this));
        //this.event('click', '.js-search-reset', this.resetSearchForm.bind(this));
        this.event('click', '.js-banner-close', this.onBannerClose.bind(this));
        this.event('click', '.header__search-form-close', this.headerSearchBarClose.bind(this));
        this.event('click', '.header__search-form', this.headerSearchBarExpand.bind(this));
        //this.event('focusout', '.header__search-input', this.headerSearchBarClose.bind(this));

        $(document).ready(function () {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/android/i.test(userAgent)) {
            $('body').addClass('android-device');
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('body').addClass('ios-device');
            }
        });

        $('.show-icon').on("click",function (){
            var $input = $(this).parents(".form-row_field").find("input[type='password']")
            if ($input.attr("type") == "password") {
                $input.attr("type", "text");
            } 
            $input.siblings('.show-icon').hide();
            $input.siblings('.hide-icon').show();
        });

        $('.hide-icon').on("click",function (){
            var $input = $(this).parents(".form-row_field").find("input[type='text']");
            if ($input.attr("type") == "text") {
                $input.attr("type", "password");
            } 
            $input.siblings('.show-icon').show();
            $input.siblings('.hide-icon').hide();
        });

        $(document).on('click', function(e){
            if(!$(e.target).closest('.header__search').length && !$(e.target).closest('.header__search-button').length) {
                if($('.search-bar-open').length || $('.header--suggestion-show').length) {
                    this.headerSearchBarClose();
                }
            }
        }.bind(this));

        $('.js-search-reset').on('click', function(){
            searchsuggest.clearResults();
            $('.js-simple-search-input').val('').focus();
        });
     
        this.changeTopLevelActiveCategory = true;
        if (!layout.isMobileView()) {
            $('.thirdLevels').removeClass('active');
        }
        this.event('mouseenter', '.category-nav__item-link', this.activateTopLevelCategory.bind(this));
        this.event('mouseleave', '.category-nav__item-link', this.onTopLevelMouseLeft.bind(this));
        this.event('touchend', '.category-nav__item-link', this.activateTopLevelCategory.bind(this));
        this.handleMobileNavEmptySpace();
    }

    onWindowModeChanged(modeData) {
        if (!modeData) {
            return;
        }

        var {mode} = modeData;
        if (mode === 'medium' || mode === 'small') {
            this.activeViewMode = 'mobile';
        } else {
            this.activeViewMode = 'desktop';
        }

        this.headerNavigationContainer.setViewMode(this.activeViewMode);

        if (this.activeViewMode === 'mobile') {
            this.headerNavigationContainer.rebuildMenuLinks();
        }
        this.headerNavigationContainer.initNavigationStyles();

        this.setMobileHeaderPositionTop();
        this.initTransparency();

        if (this.isTablet) {
            if (layout.isLandscape()) {
                // close navigation menu
                this.headerNavigationContainer.deactivate();
            }

            if (layout.isPortrait() && this.$el.find('.js-header').hasClass('is--touched')) {
                this.$el.find('.js-header').removeClass('is--touched');
                this.$el.find('.js-overlay-nav').removeClass('is--expanded');
            }
        }
    }

    updateChildrenReferences() {
        CHILDREN_COMPONENTS_IDS.forEach((childComponentId) => {
            this.getById(childComponentId, (childComponent) => {
                this[childComponentId] = childComponent;
            });
        });
    }

    subscribeToChildrenEvents() {
        this.onChild('headerNavigationContainer', 'headerNavigation.state.activated', this.onHeaderNavigationActivated.bind(this));
        this.onChild('headerNavigationContainer', 'headerNavigation.state.deactivated', this.onHeaderNavigationDeactivated.bind(this));
        this.onChild('headerNavigationContainer', 'headerNavigation.link.touched', this.onLinkTouched.bind(this));
        this.onChild('headerNavigationContainer', 'headerNavigation.link.touched.largeView', this.onLargeViewLinkTouched.bind(this));
        this.onChild('headerNavigationContainer', 'headerNavigation.menuTab.mouseEntered', this.onMenuTabMouseEntered.bind(this));
        this.onChild('headerNavigationContainer', 'headerNavigation.menuTab.mouseLeft', this.onMenuTabMouseLeft.bind(this));

        this.onChild('headerSearchContainer', 'headerSearch.show', this.onHeaderSearchShow.bind(this));
        this.onChild('headerSearchContainer', 'headerSearch.hide', this.onHeaderSearchHide.bind(this));
        this.onChild('headerSearchContainer', 'headerSearch.search.bar.focus', this.onHeaderSearchFocusOnce.bind(this));
        this.onChild('headerSearchContainer', 'headerSearch.search.bar.blur', this.onHeaderSearchBlur.bind(this));
    }

    subscribeToGlobalEvents() {
        this.eventMgr('window.modechanged', this.onWindowModeChanged.bind(this));
        this.eventMgr('miniCart.toggled', () => {
            this.headerNavigationContainer.deactivate();
        });
        this.eventMgr('window.resize', this.setMobileHeaderPositionTop);
        this.eventMgr('gdpr.closed', this.setMobileHeaderPositionTop);
        this.eventMgr('miniCart.show', this.setMobileHeaderPositionTop);
        this.eventMgr('searchSuggest.show', this.setMobileHeaderPositionTop);
    }

    initTransparency() {
        let screenConfig = this.$el.find('.js-header').data('screenConfig');
        let viewType = layout.getMode();
        let currentScreenConfig = (screenConfig && window.pageContext.type && screenConfig[window.pageContext.type]) ||
                            (screenConfig && window.pageContext.currentPage && screenConfig[window.pageContext.currentPage]) ||
                            (screenConfig && window.pageContext.ns && screenConfig[window.pageContext.ns]);
        let availableScreens = currentScreenConfig ? currentScreenConfig.screens.split(',') : [];

        // if (availableScreens.indexOf(viewType) > -1) {
        //     $(document).find('#wrapper').addClass('is--transparent');
        // } else {
        //     $(document).find('#wrapper').removeClass('is--transparent');
        // }
    }

    initCatFlyoutInactive (){
        if (!layout.isMobileView()) {
            $('.thirdLevels').removeClass('active');
        }
    }

    initSlotConfigDisabled() {
        //for 8 columns layout, hide the slot
        let submenyWithContentSlot = $('.category-nav__dropdown-inner.large-last-menu-items .large-last-category-menu .submenu-with-content-slot');
        submenyWithContentSlot.hide();
        submenyWithContentSlot.prev('li.submenu').css('margin-right', '0');
    }

    initSlotConfigEnabled() {
        //for 7 columns layout,if the slot exist, add class seven-col-menu-items
        $('.category-nav__dropdown-inner.seven-col-menu-items').each(function () {
            const $ul = $(this)

            const lastElementChild = $ul.children().filter(function() {
                return this.nodeType === 1; // Ensure it's an element node
            }).last();

            const hasLastChildLi = lastElementChild.is('li');
            if (hasLastChildLi) {
                $ul.addClass('seven-col-without-active-slot').removeClass('seven-col-with-active-slot')
            } else {
                $ul.addClass('seven-col-with-active-slot').removeClass('seven-col-without-active-slot')
            }
        });

        $('.category-nav__dropdown-inner.small-last-menu-items').each(function () {
            const $ul = $(this)

            const lastElementChild = $ul.children().filter(function() {
                return this.nodeType === 1; // Ensure it's an element node
            }).last();

            const hasLastChildLi = lastElementChild.is('li');

            if (hasLastChildLi) {
                $ul.addClass('small-last-menu-none').removeClass('small-last-menu-margin')
            } else {
                $ul.addClass('small-last-menu-margin').removeClass('small-last-menu-none')
            }
        })

        $('li.submenu-with-content-slot').each(function () {
            const el = this;
            let hasVisibleContent = false;

            for (let i = 0; i < el.childNodes.length; i++) {
                const node = el.childNodes[i];

                if (node.nodeType === Node.ELEMENT_NODE) {
                    hasVisibleContent = true;
                    break;
                }

                if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
                    hasVisibleContent = true;
                    break;
                }
            }

            if (!hasVisibleContent) {
                $(el).hide();
                $(el).prev('li.submenu').css('margin-right', '0');
            }
        });
    }

    setMobileHeaderPositionTop() {
        let headerHeight = this.$el.find('.js-header').find('.js-header-inner').height();
        let isTopBannerHidden = this.$el.find('.js-top-banner').hasClass('c-header-top-banner--hidden');
        // eslint-disable-next-line max-len
        let topBannerHeight = this.$el.find('.js-top-banner').length && !isTopBannerHidden && this.$el.find('.js-top-banner').outerHeight();
        // eslint-disable-next-line max-len
        let cookieMsgHeight = this.$el.find('.js-cookies-message').is(':visible') && this.$el.find('.js-cookies-message').height();
        let navTop = headerHeight + cookieMsgHeight + topBannerHeight;
        let headerTop = topBannerHeight + cookieMsgHeight;
        let isMiniCartActive = $(document.documentElement).hasClass('is--mini-cart-show');
        let isSuggestionShown = $('body').hasClass('is--suggestion-show');
        let isMenuActive = $(document.documentElement).hasClass('is--menu-active');


        if (!isMenuActive) {
            this.$el.find('.js-header').find('.js-header-inner').css('top', 0);
        }

        if (this.activeViewMode === 'mobile' && !(this.isTablet && layout.isLandscape())) {
            if (isMenuActive || isSuggestionShown) {  
                this.$el.find('.js-header').find('.js-header-inner').css('top', headerTop);
                let headerTopHeight = this.$el.find('.c-header-top-banner').height();
                let headerHeight = this.$el.find('.js-header').find('.js-header-inner').height();
                let headerHeightTotal = headerTopHeight + headerHeight;
                $('.js-nav-system-subnav-item .submenu-links-content').css('top', headerHeightTotal);
            }
        }
    }

    toggleNavigation() {
        this.headerNavigationContainer.toggleActiveState();
        $(document).trigger('minicart.close');
    }

    onOverlayClick() {
        this.headerNavigationContainer.deactivate();
    }

    /**
     * @description toggle simple search form
     */
    toggleSearchForm() {
        this.headerSearchContainer.toggleSearchForm(false);
        if(layout.isMobileView()){
            this.$el.find('.js-header').addClass('search-bar-open');
        }
    }
    
    removeTransparentHeader(removeTransparent) {
        var currentScroll = $(window).scrollTop();
        if((!currentScroll > 0) && this.isTransparentEnabled) {
            if(removeTransparent) {
                $('.header').removeClass('transparent');
            } else {
                $('.header').addClass('transparent');
            }
        }
    }

    setActiveSubCategory(isActive) {
        var activeCategory = $('.js-category-navigation .category-nav__item .category-nav__item-link.active').data('category-id');
        if (isActive) {
            this.$el.find('.js-header').addClass('is--active-sub-category');
            $("ul.thirdLevels").each(function(index) {
                if($(this).data('category-id') === activeCategory) {
                    $(this).addClass('active-state');
                    return;
                }
            });
        } else {
            this.$el.find('.js-header').removeClass('is--active-sub-category');
            $("ul.thirdLevels").each(function(index) {
                if($(this).data('category-id') === activeCategory) {
                    $(this).removeClass('active-state');
                    return;
                }
            });
        }
    }

    onBannerClose(el, e) {
        e.preventDefault();
        cookie.set(Resources.COOKIE_BANNER_CLOSED, 'true');
        this.$el.find('.js-top-banner').addClass('c-header-top-banner--hidden');
        this.setMobileHeaderPositionTop();
    }

    headerSearchBarExpand(){
        if(!layout.isSmallView()){
            this.$el.find('#header').addClass('header--suggestion-show');
            this.$el.find('.header__search-input').attr('placeholder', '');
        }
        this.removeTransparentHeader(true);
    }

    headerSearchBarClose(){
        this.$el.find('.header__search-input').attr('placeholder', Resources.SERACH);
        this.$el.find('.header__search-input').val('');
        this.$el.find('.js-overlay-nav ').removeClass('is--expanded');
        if($('div').hasClass('pt_storefront homepage') || $('div').hasClass('pt_categorylanding')) {
            this.removeTransparentHeader(false);
        }
        if(layout.isMobileView()){
            this.toggleSearchForm();
            this.$el.find('.js-header').removeClass('search-bar-open');
        }
        setTimeout(function () {
            $('.js-header').removeClass('header--suggestion-show');
            $('#search-suggestions').css('display','none');
        }, 200);
    }

    onHeaderNavigationActivated() {
        $(document.documentElement).addClass('is--menu-active');
        this.$el.find('.js-overlay-nav').addClass('is--mobile-expanded');
        this.hideSearchForm();
        this.setMobileHeaderPositionTop();
        this.removeTransparentHeader(true);
        this.setActiveSubCategory(true);
    }

    onHeaderNavigationDeactivated() {
        $(document.documentElement).removeClass('is--menu-active');
        this.$el.find('.js-overlay-nav').removeClass('is--mobile-expanded');
        this.hideOverlay();
        this.setMobileHeaderPositionTop();
        this.removeTransparentHeader(false);
        this.setActiveSubCategory(false);
    }

    onLinkTouched() {
        this.$el.find('.js-overlay-nav').addClass('is--expanded');
        this.$el.find('.js-header').addClass('is--touched');

        $(document).trigger('minicart.close');
    }

    onLargeViewLinkTouched() {
        this.hideSearchForm();
    }

    activateTopCategory($topCat) {
        var $secondLevelContainer = $('.category-nav__item__level2');
        var categoryName = '';
        var isHoverOut = !$topCat || !$topCat.length;
    
        // If hovering over a category (hover-in)
        if (!isHoverOut) {
            categoryName = $topCat.data('category-class');
        } else {
            if ($('#wrapper').hasClass('pt_categorylanding') || $('#wrapper').hasClass('pt_product-details') || ($('#wrapper').hasClass('pt_product-search-result') && pageContext.type === 'plp')) {
               // Hover-out: Get the active category from data-active-cat (for other pages)
                var defaultCat = $('.level-1').attr('data-active-cat');
                if (defaultCat) {
                    categoryName = defaultCat;
                    $topCat = $('.level-1').find('.' + categoryName + ':visible');
                }
            } else {
                 // Ignore data-active-cat on any other page then clp, plp, pdp - homepage/cart/order confirmation
                 categoryName = ''; 
            }
        }
    
        var $categoryItem = ($topCat && $topCat.length) ? $topCat.closest('li') : null;
    
        // If category is found (either by hover-in or default category on hover-out)
        if (categoryName && $topCat && $topCat.length && $categoryItem && $categoryItem.length) {
            if (!isHoverOut && !$secondLevelContainer.is(':visible')) {
                $secondLevelContainer.removeClass('hide-mobile');
            }
    
            // Highlight current category (remove any other active links first)
            $('.level-1 > li a').removeClass('active');
            $topCat.addClass('active');
            
            if (!isHoverOut) {
                $secondLevelContainer.find('.' + categoryName).addClass('active').siblings().removeClass('active');
            } else {
                // On hover-out, hide all subcategories
                $secondLevelContainer.find('ul').removeClass('active');
            }
        } else {
            // On homepage hover-out: remove all active states
            $('.level-1 > li a').removeClass('active');
            $secondLevelContainer.find('ul').removeClass('active');
        }
    }
    

    onMenuTabMouseEntered() {
        this.changeTopLevelActiveCategory = false;
        this.removeTransparentHeader(true);
        this.$el.find('.js-overlay-nav').addClass('is--expanded');
        //this.hideSearchForm();
        $(document).trigger('minicart.close', $('.js-mini-cart-content').hasClass('is--hidden'));
        if (this.activeViewMode === 'desktop') {
            this.removeTransparentHeader(true);
        }
    }

    onMenuTabMouseLeft() {
        let outerContext = this;
        this.changeTopLevelActiveCategory = true;
        this.$el.find('.js-overlay-nav').addClass('is--expanded');
        //$('.js-header').addClass('hide');
        //this.hideSearchForm();
        $(document).trigger('minicart.close', $('.js-mini-cart-content').hasClass('is--hidden'));
        if (!layout.isMobileView()) {
                if(outerContext.changeTopLevelActiveCategory) {
                    outerContext.activateTopCategory();
                    outerContext.removeTransparentHeader(false);
                }
        }
    }

    onHeaderSearchShow() {
        $(document).trigger('minicart.close', true);
        this.headerNavigationContainer.deactivate();
        this.$el.find('.js-overlay-nav').addClass('is--expanded');
        $(document.documentElement).addClass('is--header-search-show');
        this.removeTransparentHeader(true);
    }

    onHeaderSearchHide() {
        this.hideOverlay();
        $(document.documentElement).removeClass('is--header-search-show');
        $('.header__search-form-close').removeClass('search-close-icon-btn');
        if(!$('.tab-content:visible').length) {
            this.removeTransparentHeader(false);
        } else {
            this.removeTransparentHeader(true);
        }
        setTimeout(function () {
            $('#search-suggestions').css('display','none');
        }, 200);
    }

    hideOverlay() {
        this.$el.find('.js-overlay-nav').removeClass('is--mobile-expanded');
        this.$el.find('.js-overlay-nav').removeClass('is--expanded');
    }

    hideSearchForm() {
        this.headerSearchContainer.hideSearchForm();
    }

    onHeaderSearchFocusOnce() {
        if (!this.isSearchFocused) { 
            this.isSearchFocused = true; 
            this.onHeaderSearchFocus(this.isSearchFocused); 
        }
    }

    onHeaderSearchFocus(isFocused) {
        $(document).trigger('minicart.close', isFocused);

        // add focused state class to component container
        this.$el.addClass('is--search-input-focused');
        this.$el.find('.header__search-form-close').show();

        if (!layout.isMobileView() || !this.headerNavigationContainer.isActive()) {
            return;
        }
        this.headerNavigationContainer.deactivate();
    }

    onHeaderSearchBlur() {
        // remove focused state class to component container
        this.$el.removeClass('is--search-input-focused');
        this.isSearchFocused = false; 
    }

    activateTopLevelCategory(el, e) {
        if(layout.isMobileView()) {
            e.preventDefault();
            $('.category-nav__dropdown-content .thirdLevels.active-state').each(function() {
                $(this).removeClass('active-state');
            });
        }
        this.changeTopLevelActiveCategory = false;
        this.removeTransparentHeader(true);
        const $this = $(el);
        this.activateTopCategory($this);
    }

    onTopLevelMouseLeft() {
        let outerContext = this;
        this.changeTopLevelActiveCategory = true;
        setTimeout(function(){
            if(outerContext.changeTopLevelActiveCategory) {
                outerContext.removeTransparentHeader(false);
                outerContext.activateTopCategory();
            }
        }, 1000);
    }

    // Fix empty white space in header navigation - search results
    handleMobileNavEmptySpace() {
        const categoryName = $('.level-1').attr('data-active-cat');
        const $secondLevelContainer = $('.category-nav__item__level2');
        if(categoryName && $secondLevelContainer.find('.' + categoryName).length) {
            $secondLevelContainer.removeClass('hide-mobile');
        } else {
            $secondLevelContainer.addClass('hide-mobile');
        }
    }
}
